import { useQuery } from "@apollo/client";

import { CourseEditRoute_GetByIdDocument } from "../queries.generated";

export default function useCourseEditRoute_GetById(courseId: string) {
    const { data, loading, error } = useQuery(CourseEditRoute_GetByIdDocument, {
        variables: { id: courseId },
    });

    return {
        loading,
        error,
        data: data?.courseGetById,
    };
}
